<app-navbar></app-navbar>
<app-slide></app-slide>
<app-card></app-card>
<app-footer></app-footer>
<guest-booking/>
